import * as yup from 'yup';
import { validateSsn } from '../../../helpers/formHelpers/formHelpers';

export interface IRegistration {
	fullName: string;
	identificationNumber: string;
	email: string;
	password: string;
	phoneNumber: string;
	passwordConfirm: string;
}

export const registrationInitialValues: IRegistration = {
	fullName: '',
	identificationNumber: '',
	email: '',
	phoneNumber: '',
	password: '',
	passwordConfirm: '',
};

export const registrationSchema = yup.object().shape({
	fullName: yup.string().required('fullName-required'),
	identificationNumber: yup
		.string()
		.required('socialId-required')
		.min(10, 'socialId-min')
		.test('is-valid-ssn', 'invalid-socialid', validateSsn),
	email: yup.string().email().required('required'),
	phoneNumber: yup
		.string()
		.min(7, 'phoneMustBe7')
		.max(7, 'phoneMustBe7')
		.matches(/^[6-8][0-9]*$/, 'phoneMustBe7')
		.required('required'),
	password: yup.string().required('required').min(6, 'passwordLengthError'),
	passwordConfirm: yup
		.string()
		.oneOf([yup.ref('password')], 'passwordConfirmError')
		.required('required'),
});
